// All runtime endpoints. Values fall back to defaults that work against a
// local Function URL + a `terraform output` for Cognito. Override at build
// time with REACT_APP_* env vars.

interface EnvironmentConfig {
  apiBaseUrl: string;             // Lambda Function URL, no trailing slash
  cognito: {
    domain: string;               // e.g. https://pancakestack-prod-....auth.us-east-1.amazoncognito.com
    clientId: string;             // web client id
    region: string;
    scopes: string[];
  };
}

const strip = (v: string) => v.replace(/\/+$/, '');

const env = (key: string, fallback: string = ''): string => {
  const v = process.env[key];
  if (!v && !fallback) {
    // eslint-disable-next-line no-console
    console.warn(`[env] missing ${key}`);
  }
  return v || fallback;
};

export const environment: EnvironmentConfig = {
  apiBaseUrl: strip(env('REACT_APP_API_BASE_URL', '')),
  cognito: {
    domain:   strip(env('REACT_APP_COGNITO_DOMAIN', '')),
    clientId: env('REACT_APP_COGNITO_CLIENT_ID', ''),
    region:   env('REACT_APP_AWS_REGION', 'us-east-1'),
    scopes:   ['openid', 'email', 'profile'],
  },
};

export default environment;
